import classNames from "classnames";
import {Disclosure} from "@headlessui/react";
import AnimateHeight from "react-animate-height";
import ChevronIcon from "@autocx/icons/src/chevron-icon";
import _cloneDeep from "lodash/cloneDeep";
import _isFunction from "lodash/isFunction";
import {useContext} from "react";

import FormContext from "../form-context";

export default function Details(props) {
    const context = useContext(FormContext);
    const title = _isFunction(props.title) ? props.title(_cloneDeep(context.values)) : props.title;
    const value = _isFunction(props.value) ? props.value(_cloneDeep(context.values)) : props.value;
    const className = _isFunction(props.className) ? props.className(context.values) : props.className;

    return (
        <Disclosure as="div" className={className}>
            {({open}) => (
                <>
                    <Disclosure.Button
                        as="div"
                        data-accordion-trigger={props.name || title}
                        className="group flex w-full cursor-pointer items-center justify-between"
                    >
                        <span className="text-sm font-semibold text-gray-700 group-hover:text-link">
                            {title}
                        </span>
                        <span className={classNames(
                            "h-5 w-5 border-current group-hover:text-link",
                            open ? "chevron--up" : "chevron--down"
                        )}>
                            <ChevronIcon/>
                        </span>
                    </Disclosure.Button>
                    <AnimateHeight
                        duration={200}
                        height={open ? "auto" : 0}
                        animateOpacity
                    >
                        <Disclosure.Panel
                            static
                            data-accordion-panel
                            className="pt-2 text-xs leading-5 text-gray-600"
                        >
                            {value}
                        </Disclosure.Panel>
                    </AnimateHeight>
                </>
            )}
        </Disclosure>
    );
}
